import { ITimeoutService } from 'angular';
import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';


import { OpenMasterBuyDialogAction } from './family-plan-master-buy-dialog.action';

import { IWindowService } from 'angular';
import { FamilyPlanTypes } from '../../common/services/package/package.model';

/* @ngInject */
export default class OpenMasterBuyDialogController implements ActionHandler {
  private dialogElement;
  private type: FamilyPlanTypes;
  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    private $state,
    private $timeout: ITimeoutService,
    private $window: IWindowService
  ) {}

  public $postLink() {
    this.dialogElement = this.$element.find('#family-plan-master-buy-dialog').remodal();
    this.actionDispatcher.register(this);
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof OpenMasterBuyDialogAction) {
      this.type = action.type;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  public onGoInfo() {
    this.close();
    if (this.isDuoPackage()){
      this.$state.go('duoPlan');
    } else {
      this.$state.go('familyPlan');
    }
  }

  public isActive(destination: string) {
    return destination === this.$window.location.pathname;
  }

  private close() {
    this.dialogElement.close();
  }

  public onClose() {
    this.close();
    this.$state.go('myAccount');
  }

  public isDuoPackage() {
    return this.type == FamilyPlanTypes.DUO;
  }
}



// WEBPACK FOOTER //
// ./src/app/family-plan/family-plan-master-buy-dialog/family-plan-master-buy-dialog.controller.ts